/// <reference path="callCenter.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CallCenter {
  import ModalOptions = Meevo.Components.Modal.IModalOptions;

  class CallCenterController {

    static $inject = [
      "meevo.AppSettings", "meevo.components.common.DataService",
      "meevo.components.modal.ModalService", "meevo.components.common.IdentityService",
        "meevo.components.logging.LoggingService",
        "meevo.components.common.SecurityService",
        "meevo.components.tracking.TrackingService",
      "$rootScope", "$scope", "$state", "meevo.ContextParams", 'meevo.components.short-cuts.ShortCutsService', "meevo.components.busy.BusyService",
      "$mdDialog", "$filter", "$mdToast", "$translate", "$timeout", "$window", "meevo.menuService"
      ];

    protected appointmentBookRead = Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
    protected waitListAdd = Meevo.Components.Common.SecurityKeys.APPOINTMENTS_WAITLIST + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
    protected dataClientTabMain = Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_MAIN;

    protected clients: any;
    protected deleteClient: Function;
    protected toggleDateSelect: Function;
    protected toggleTimeRangeSelect: Function;
    protected scan: any;
    protected scanned: any;
    protected currentDetailView: string;
    protected location: any;
    protected payingClient: any;
    protected showEmployeesOnly: any = { showEmployeesOnly: true }
    protected employeeExclusionList: any;
    protected timeTypeExclusionList: any;
    protected dateTypeExclusionList: any;
    protected openings: any;
    protected basePriceLevels: any;
    protected startDate: any;
    protected endDate: any;
    protected startTime: any;
    protected endTime: any;
    protected defaultStartTime: any;
    protected defaultEndTime: any;
    protected numWeeksToAdd: number;
    protected showMoreResults: boolean;
    protected showMissedOpportunity: number;
    protected showAddToWaitList:number;
    protected maxOpeningsPerDay: number;
    protected appointmentBufferMinutes: number;
    protected lastOpeningTime: any;
    protected appointDetail: any;
    protected employeeCriteria: any = {
      showEmployeesOnly: true,
      includeSharedEmployee: true
    };
    protected currentCallCenterScreen: number;
    protected updateCurrentScreen: Function;
    protected appointmentBookSettings: Meevo.Model.AppointmentBookSettings;
    protected emulationUrl: string = '/CallCenter/Emulate';
    protected locationSearchCriteria: { filterBySessionUser: boolean, excludeIdList: number[] }
    protected canBookLoggedInLocation: boolean;
    protected timeZoneOffset: number;    

    private loggedInLocation: any;
    private previousLocation: any;
    private showViewBook: boolean;
    private excludeScanDateTimeRanges: Model.DateTimeRange[] = [];

    private get effectiveLocationId(): number {
      if (!this.canBookLoggedInLocation && Model.Guard.isNothing(this.location)) {
        return undefined;
      }

      return this.location && this.location.locationId ? this.location.locationId : this.identityService.locationId;
    }

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
        protected dataService: Meevo.Components.BaseClasses.IDataService,
        protected modalService: Meevo.Components.Modal.IModalService,
        protected identityService: Meevo.Components.Common.IIdentityService,
        protected loggingService: Meevo.Components.Logging.ILoggingService,
        protected securityService: Meevo.Components.Common.ISecurityService,
        protected trackingService: Meevo.Components.Tracking.ITrackingService,
        protected $rootScope: angular.IRootScopeService,
        protected $scope: angular.IScope,
        protected $state: any,
        protected contextParams: Meevo.IContextParams,
        protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
        protected busyService: Meevo.Components.Busy.IBusyService,
        protected $mdDialog: angular.material.IDialogService,
        protected $filter: angular.IFilterService,
        protected $mdToast: angular.material.IToastService,
        protected $translate: angular.translate.ITranslateService,
        protected $timeout: angular.ITimeoutService,
        protected $window: angular.IWindowService,
        protected menuService: Meevo.MenuService) {

        var vm = this;
        vm.currentDetailView = "overview";
        // TODO: Get the following from settings.
        vm.maxOpeningsPerDay = 8;
        vm.appointmentBufferMinutes = 0;
        vm.appointDetail = {};

        vm.dataService.getEnumList(Meevo.Model.EnumTypeEnum.PriceLevelEnum)
          .then((response: any) => {
            vm.basePriceLevels = _.clone(response);
            vm.basePriceLevels.unshift({
              id: 0,
              value: "AllLevels",
              displayName: "All Levels"
            });
            vm.resetCriteria();
            return response;
            });

        vm.currentCallCenterScreen = 0;
        vm.updateCurrentScreen = () => {
            if (vm.currentCallCenterScreen == 0)
                vm.currentCallCenterScreen = 1;
            else
                vm.currentCallCenterScreen = 0;
        }

        vm.timeTypeExclusionList = [
          Meevo.Model.ScanTimeTypeEnum.Morning,
          Meevo.Model.ScanTimeTypeEnum.Afternoon,
          Meevo.Model.ScanTimeTypeEnum.Evening
        ];

        vm.dateTypeExclusionList = [Meevo.Model.ScanDateTypeEnum.Today];

        vm.deleteClient = (item: any) => {
            var index = vm.clients.indexOf(item);
            vm.clients.splice(index, 1);
        }

        vm.toggleDateSelect = () => {
            let options = {
                templateUrl: 'app/plugins/callCenter/views/dateSelection.modal.html',
                controller: 'meevo.plugins.callCenter.callCenterModalController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    item: { startDate: this.startDate, endDate: this.endDate }
                }
            };
            this.modalService.showCustom(options)
              .then((response: any) => {
                this.startDate = response.startDate;
                this.endDate = response.endDate;
                return response;
              });
        }

        vm.toggleTimeRangeSelect = () => {
            let options = {
                templateUrl: 'app/plugins/callCenter/views/timeRange.modal.html',
                controller: 'meevo.plugins.callCenter.callCenterModalController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    item: {
                      startTime: this.startTime,
                      endTime: this.endTime,
                      timeType: Number(this.scan.timeType)
                    }
                }
            };

            this.modalService.showCustom(options)
              .then((response: any) => {
                this.startTime = response.startTime;
                this.endTime = response.endTime;
                return response;
              });
        }

        vm.scan = {
            filter: {
                days:[]
            },
            dateType: <number>Meevo.Model.ScanDateTypeEnum.FirstAvailable,
            timeType: <number>Meevo.Model.ScanTimeTypeEnum.Anytime,
            maxWait: 15,
            multipleClients: false,
            requireSameResource: false
        };

        vm.locationSearchCriteria = {
          filterBySessionUser: true,
          excludeIdList: [this.identityService.current().callCenterId, this.identityService.current().centralOfficeId]
        };

        var request = {
          criteria: vm.locationSearchCriteria
        };

        this.$scope.$on(Meevo.Components.Common.Messages.CONTEXT_HAS_CLOSED, (event, state, params) => {
          if (state === this.appSettings.ROUTE_NAMES.callCenter) {
            this.location = undefined;
            this.emulate();
          }
        });

        this.$scope.$on(Meevo.Components.Common.Messages.CALL_CENTER_EMULATION_CHANGE, (event, args) => {
          if (!args || !args.emulationData) {
            return;
          }
          const newEmulationData = args.emulationData;
          const skipClosingTabs = Model.Guard.isSomething(args) && args.skipClosingTabs;
          this.automaticallyUpdateLocationAndEmulate(newEmulationData.asImpersonateLocationId, skipClosingTabs);
        });

        this.canBookLoggedInLocation = !this.identityService.inCallCenterMode() 
                                       && this.securityService.hasSecurity(Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_ADDAPPOINTMENT);

        this.loggedInLocation = {
          locationId: this.identityService.locationId,
          storeName: this.identityService.current().locationName
        }
        
        const identityData = this.identityService.emulationData;

        if (this.identityService.isEmulating
          && identityData.asImpersonateLocationId
          && identityData.effectiveCallCenterId > 0
          && identityData.asImpersonateLocationId > 0) {

            var newLocationId = identityData.asImpersonateLocationId;
            this.automaticallyUpdateLocationAndEmulate(newLocationId);

        } else if (this.canBookLoggedInLocation || this.identityService.isSingleLocation()) {

          this.location = this.loggedInLocation;
          this.emulate();
          this.setLocSettings(this.appSettings.APP_BUSINFOSETTINGS.appointmentBookSettings);  

        } 
 }

    setLocSettings = (appointmentBookSettings: Model.AppointmentBookSettings) => {
        this.appointmentBufferMinutes = 0;

        this.employeeExclusionList = [
            Meevo.Model.EmployeeGenderSearchEnum.RandomEmployee
        ];

        this.clients = [];
        this.appointmentBookSettings = appointmentBookSettings;
        if (this.appointmentBookSettings === undefined ||
            (this.appointmentBookSettings.hideAnyMaleAnyFemaleInCallCenter !== undefined &&
            this.appointmentBookSettings.hideAnyMaleAnyFemaleInCallCenter)) {
            this.employeeExclusionList.push(Meevo.Model.EmployeeGenderSearchEnum.AnyMale);
            this.employeeExclusionList.push(Meevo.Model.EmployeeGenderSearchEnum.AnyFemale);
        }
        if (this.appointmentBookSettings === undefined ||
            (this.appointmentBookSettings.enableEmployeeSearch !== undefined &&
            !this.appointmentBookSettings.enableEmployeeSearch)) {
            this.employeeExclusionList.push(Meevo.Model.EmployeeGenderSearchEnum.SpecificEmployee);
        }
        this.setAppointmentBufferMinutes();
      }
      setAppointmentBufferMinutes() {
          if (this.appointmentBookSettings === undefined ||
              (this.appointmentBookSettings.preventAppointmentsFromBeingBookedForXHours !== undefined)) {
              this.appointmentBufferMinutes = (this.appointmentBookSettings.preventAppointmentsFromBeingBookedForXHours * 60);
          }
      }

    toggleDetailView = (detail: string): void => {
        this.currentDetailView = detail;
    }

    closeContext = (): void => {
      this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
    }

    addClient = () => {

        this.clients.push({
            lastName: "",
            firstName: "",
            service: null,
            priceLevels: this.basePriceLevels ? this.basePriceLevels.slice(0) : null,
            priceLevel: this.basePriceLevels ? this.basePriceLevels[0].id : null,
            employee: null,
            genderPreference: Meevo.Model.EmployeeGenderSearchEnum.AnyEmployee.toString(),
            employeeGenderSearchEnum: Meevo.Model.EmployeeGenderSearchEnum.AnyEmployee.toString(),

        });
    }

    copyClient = (client: any) => {
      var newClient = _.clone(client);
      newClient.client = null;
      this.clients.push(newClient);
    }

    locationUpdated = () => {
      if (Model.Guard.isNothing(this.location) && this.canBookLoggedInLocation)
        this.location = this.loggedInLocation;

      if (this.previousLocation === this.location)
        return;
      
      this.$rootScope.$broadcast(Components.Common.Messages.CLOSE_REMOTE_CONTEXTS);
      this.emulate();
      this.resetCriteria();
    }

    changeLocation = (location: any) => {
      this.location = location.location;
      this.locationUpdated();
      this.$mdDialog.hide();
    }

    resetCriteria = () => {

      this.clients = [];
      this.payingClient = null;
      this.openings = [];
      this.showMoreResults = false;
      this.numWeeksToAdd = 0;
      this.showAddToWaitList = 0;
      this.showMissedOpportunity = 0;
      this.startDate = moment().startOf('day').toDate();
      this.endDate = moment(this.startDate).add(1, 'd').toDate();
      this.excludeScanDateTimeRanges = [];

      this.scan = {
        filter: {
          days: [0,1,2,3,4,5,6]
        },
        dateType: <number>Meevo.Model.ScanDateTypeEnum.FirstAvailable,
        timeType: <number>Meevo.Model.ScanTimeTypeEnum.Anytime,
        maxWait: 15,
        multipleClients: false,
        requireSameResource: false
      };

      this.currentCallCenterScreen = 0;

      (document.activeElement as HTMLElement).blur();
    }

    addToWaitList = () => {
        var waitListLocationId = this.effectiveLocationId;
        var okToScan = this.clients.length > 0 &&
                waitListLocationId &&
                _.some(this.clients, (service: any) => {
                    return service.client &&
                        service.service
                        ;
                });

        if (okToScan) {

            var startDate: Date;
            var endDate: Date;

            var settingsStartDay = Model.WeekdayNameEnum[this.appointmentBookSettings.startAppointmentBookDayOn];
            const locationAdjustedMoment = this.getLocationAdjustedMoment();
            const startOfThisWeek = this.getThisWeekStartMoment(locationAdjustedMoment);

            switch (this.scan.dateType) {

              case Model.ScanDateTypeEnum.FirstAvailable:
                startDate = moment(locationAdjustedMoment).toDate();
                endDate = moment(locationAdjustedMoment).add(6, 'days').toDate();
                break;

              case Model.ScanDateTypeEnum.NextWeek:
                startDate =  moment(startOfThisWeek).add(7, 'days').toDate();
                endDate = moment(startDate).add(6, 'days').toDate();
                break;

              case Model.ScanDateTypeEnum.NextWeekend:
                startDate = moment(locationAdjustedMoment).day('Saturday').add(7, 'days').toDate();
                endDate = moment(startDate).add(1, 'days').toDate();
                break;
              
              case Model.ScanDateTypeEnum.ThisWeek:
                startDate = moment(locationAdjustedMoment).toDate();
                endDate = moment(startOfThisWeek).add(6, 'days').toDate();
                break;
              
              case Model.ScanDateTypeEnum.ThisWeekend:
                var thisSunday = moment(locationAdjustedMoment).day('Sunday').toDate();
                var isTodaySunday = moment(locationAdjustedMoment).toDate() === thisSunday;
                
                if (isTodaySunday) {
                  startDate = endDate = thisSunday;
                  break;
                }

                startDate = moment(locationAdjustedMoment).day('Saturday').toDate();
                endDate = moment(startDate).add(1, 'days').toDate();
                break;

              case Model.ScanDateTypeEnum.Today:
                startDate = endDate = moment(locationAdjustedMoment).toDate();
                break;
              
              case Model.ScanDateTypeEnum.Tomorrow:
                startDate = endDate = moment(locationAdjustedMoment).add(1, 'days').toDate();
                break;

              default:
                startDate = this.startDate;
                endDate = this.endDate;
            }

            let clientServices = this.clients;
            
            let startTime = this.startTime ? this.startTime : this.defaultStartTime;
            let endTime = this.endTime ? this.endTime : this.defaultEndTime;

                var request: Model.AppointmentRequest = {
                    payingClientId: clientServices[0].client.id,
                    payingClient: clientServices[0].client,
                    services: [],
                    dateTimeBands: [{
                        startTime: startTime,
                        endTime: endTime,
                        startDate: startDate,
                        endDate: endDate,
                        daysOfWeek: this.scan.filter.days
                    }],
                    locale: this.appSettings.APP_COUNTRYID,
                    timeFormat: this.appSettings.APP_TIME_FORMAT
                };

                if (clientServices.length > 1) {
                  clientServices = this.clients.filter(clientService => clientService.client.id === clientServices[0].client.id);
                }

                _.forEach(clientServices,
                    (serviceRequest: any) => {
                        if (serviceRequest.client && serviceRequest.service) {
                            var appointmentRequestService: Model.AppointmentRequestService = {
                                serviceId: serviceRequest.service.id,
                                service: serviceRequest.service,
                                employeeId: (serviceRequest.employee ? serviceRequest.employee.id : null),
                                employee: serviceRequest.employee,
                                genderPreference: Number(serviceRequest.genderPreference),
                                clientId: serviceRequest.client.id,
                                client: serviceRequest.client
                            };
                            request.services.push(appointmentRequestService);
                        }
                    });

                /**
                 * Open the WaitList and pass in the scan payload                 * 
                 */
                this.$rootScope.$broadcast(Components.Common.Messages.GOTO_STATE, {
                  stateName: this.appSettings.ROUTE_NAMES.waitList,
                  stateParams: request
                });
            }
    }

    missedOpportunity = () => {
        var missedOpportunityLocationId = this.effectiveLocationId;
        var okToScan = this.clients.length > 0 &&
            missedOpportunityLocationId &&
            _.some(this.clients, (service: any) => {
                return service.client &&
                    service.service
                    ;
            });

        if (okToScan) {
            var sd = this.scan.dateType == Model.ScanDateTypeEnum.FirstAvailable ? moment().startOf('day').toDate() : this.startDate;
            var ed = this.scan.dateType == Model.ScanDateTypeEnum.FirstAvailable ? moment().startOf('day').add(6, 'days').toDate() : this.endDate;

            var request = {
                scanOrigin: Meevo.Model.ScanOriginEnum.Default,
                scanDateType: Number(this.scan.dateType),
                scanTimeType: Number(this.scan.timeType),
                asLocationId: missedOpportunityLocationId,
                maxWaitTimeBetweenServices: this.scan.maxWait,
                maxStartTimeWait: this.scan.maxWait,
                requireSameStartTime: this.scan.multipleClients,
                requireSameResource: this.scan.requireSameResource,
                scanServices: [],
                startTime: this.startTime,
                endTime: this.endTime,
                startDate: sd,
                endDate: ed,
                daysToExclude: _.difference([0, 1, 2, 3, 4, 5, 6], this.scan.filter.days),
                appointmentBufferMinutes: this.appointmentBufferMinutes
            };

            const guidStringMap: Map<Guid, string> = new Map<Guid, string>();

            _.forEach(this.clients,
                (serviceRequest: any) => {
                    if (serviceRequest.client && serviceRequest.service) {
                        request.scanServices.push({
                            clientId: serviceRequest.client.id,
                            serviceId: serviceRequest.service.id,
                            employeeId: (serviceRequest.employee ? serviceRequest.employee.id : null),
                            genderPreferenceEnum: Number(serviceRequest.genderPreference),
                            employeeGenderSearchEnum: Number(serviceRequest.genderPreference),
                            priceLevel: (Number(serviceRequest.priceLevel) > 0 ? Number(serviceRequest.priceLevel) : null)
                        });
                        if (!guidStringMap[serviceRequest.service.id]) {
                          guidStringMap[serviceRequest.service.id] = serviceRequest.service.displayName;
                        }
                        if (serviceRequest.employee && !guidStringMap[serviceRequest.employee.id]) {
                          guidStringMap[serviceRequest.employee.id] = `${serviceRequest.employee.firstName} ${serviceRequest.employee.lastName}`;
                        }
                        if (!guidStringMap[serviceRequest.client.id]) {
                          guidStringMap[serviceRequest.client.id] = `${serviceRequest.client.firstName} ${serviceRequest.client.lastName}`;
                        }
                    }
                });

            // Pass the correct request times
            if (Number(this.scan.timeType) !== Meevo.Model.ScanTimeTypeEnum.Anytime) {
                switch (Number(this.scan.timeType)) {
                    case Meevo.Model.ScanTimeTypeEnum.EndsBefore:
                        request.startTime = this.startTime;
                        // Force scan engine to evaluate start and end times
                        request.scanTimeType = Number(Meevo.Model.ScanTimeTypeEnum.Custom);
                        break;
                    case Meevo.Model.ScanTimeTypeEnum.StartsAfter:
                        request.endTime = this.endTime;
                        // Force scan engine to evaluate start and end times
                        request.scanTimeType = Number(Meevo.Model.ScanTimeTypeEnum.Custom);
                        break;
                    default:
                        break;
                }
            }

            let uri = `/${this.appSettings.API_ROOT}/CallCenter/Opening/MissedOpportunity`;
            this.busyService.start();

            var trackingRequest = _.omit(request, ['scanOrigin', 'scanDateType', 'scanTimeType']);
            trackingRequest.scanOrigin = Meevo.Model.ScanOriginEnum[Meevo.Model.ScanOriginEnum.Default];
            trackingRequest.scanDateType = Meevo.Model.ScanDateTypeEnum[this.scan.dateType];
            trackingRequest.scanTimeType = Meevo.Model.ScanTimeTypeEnum[this.scan.timeType];
            _.forEach(trackingRequest.scanServices, (service: any) => {
                service.genderPreference = Meevo.Model.EmployeeGenderSearchEnum[service.genderPreference];
                delete service.genderPreferenceEnum;
            });
            var trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.BookingAgentPage, Meevo.Model.VerbEnum.AddToWaitListClicked, trackingRequest, null);
            this.trackingService.saveTrackingInfo(trackingItem);

            this.dataService.customMethodData(uri, 'POST', request)
                .then((results: any) => {
                    this.showMissedOpportunity = 2;

                    results.data.forEach(missedOpportunity => {
                        missedOpportunity.clientName = guidStringMap[missedOpportunity.clientId];
                        missedOpportunity.serviceName = guidStringMap[missedOpportunity.serviceId];
                        missedOpportunity.employeeName = missedOpportunity.genderPreference === Model.EmployeeGenderSearchEnum.SpecificEmployee
                            ? guidStringMap[missedOpportunity.employeeId]
                            : Model.EmployeeGenderSearchEnum[missedOpportunity.genderPreference];
                    });

                    let options = {
                      templateUrl: "app/plugins/callCenter/missedOpportunityModal.template.html",
                      controller: "meevo.plugins.callCenter.missedOpportunityModalController",
                      controllerAs: "vm",
                      bindToController: true,
                      skipHide: true,
                      locals: {
                        missedOpportunities: results.data
                      }
                    }

                    this.modalService.showCustom(options);
                })
                .finally(() => {
                    this.busyService.stop();
                    //this.currentCallCenterScreen = 1;
                });
        }
    }

      resetCriteriaWithConfirm = () => {
        this.modalService.confirm("MESSAGE_RESET_ALL_VALUES", Components.Modal.ModalTranslationModes.Translate)
            .then((resetForm: boolean) => {
              if (resetForm) {
                if (this.loggedInLocation === this.location) {
                  this.resetCriteria();
                  this.addClient();
                  return;
                }
                this.location = null;
                this.locationUpdated();
                this.$timeout(() => { angular.element('meevo-type-ahead#opensesame').find('input').focus() }, 750);
              }
            });
    }

    clientChanged = (client: any, index: number) => {
        this.commonRowChanged(client, index);
    }

    payingClientChanged = () => {
      if (this.payingClient) {
        var toast = this.$mdToast.simple();
        toast.theme("success-toast");
        toast.textContent(this.$translate.instant("LABEL_PAYING_CLIENT_NOTIFICATIONS"));
        toast.position("top right");
        toast.parent(angular.element("div#divCallCenterHeader"));
        toast.hideDelay(5000);
        toast.action("X"); // Will close the toast when clicked.
        this.$mdToast.show(toast);
      }
    }

    serviceChanged = (client: any, index: number) => {
        if (client.service) {
            this.commonRowChanged(client, index);

            let uri = `/${this.appSettings.API_ROOT}/Service/${client.service.id}/PriceLevels`;

            this.dataService.customMethodData(uri, 'GET', null)
                .then((response: any) => {
                    var levels = response.data.length;

                    if (levels > 0) {
                        client.priceLevels = this.basePriceLevels.slice(0, levels + 1);
                    }

                    uri = `/${this.appSettings.API_ROOT}/CustomData/Service/${client.service.id}/Control/List`;

                    let request = {
                      criteria: {
                        appAreaEnum: Meevo.Model.AppAreaEnum.Booking,
                        objectStateEnum: Meevo.Model.ObjectStateEnum.Active,
                        service_TId: client.service.id
                      }
                    };

                    this.dataService.customMethodData(uri, 'POST', request)
                      .then((response: any) => {
                        client.service.hasUdfs = response.data.controls.length > 0;

                        if (client.service.hasUdfs) {
                          this.showCustomControls(client.service)
                            .then((modalResponse: any) => {
                              if (modalResponse.proceed) {
                                client.service.udfs = this.appointDetail.customControlsAnswers;
                              } else {
                                client.service = null;
                              }
                              return modalResponse;
                            });
                        }
                    return response;
                });
                });
      }
    }

    editUdfs(service: any): any {
      this.showCustomControls(service)
        .then((modalResponse: any) => {
          if (modalResponse.proceed) {
            service.udfs = this.appointDetail.customControlsAnswers;
          }
          return modalResponse;
        });
    }

    showCustomControls(service: any): any {
      this.appointDetail = {
        id: NewGuid(),
        serviceId: service.id,
        serviceDisplayName: service.displayName
      };

      if (service.udfs) {
        this.appointDetail.customControlsAnswers = service.udfs;
      }

      let modalOptions: Meevo.Components.Modal.IModalOptions = {
        templateUrl: "app/plugins/AppointmentBook/views/CustomFields.html",
        controller: "meevo.plugins.appointmentbook.CustomFieldsController",
        controllerAs: "vm",
        bindToController: true,
        additionalClassName: 'appointment-custom-fields-modal',
        locals: {
          appointDetails: [this.appointDetail],
          appArea: Meevo.Model.AppAreaEnum.Booking,
          canEdit: true
        }
      };
      return this.modalService.showCustom(modalOptions);
    }

    employeeChanged = (client: any, index: number) => {
      client.employeeId = client.employee ? client.employee.id : undefined;
      if (client.employeeId) {
        client.genderPreference = null;
        client.employee.displayName = null;
      }
    }

    genderPreferenceChanged = (client: any) => {
      this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.EmployeeGenderSearchEnum)
        .then((data: any) => {
          // Hack: at runtime, genderPreference coming in as  a string not finding object in list.  Have to manually convert to int.
          let genderPreference: any = client.genderPreference;
          genderPreference = parseInt(genderPreference);
          let selectedGenderPreference: any = _.findWhere(data, { id: genderPreference });
          if (selectedGenderPreference) {
            client.employeeId = null;
            client.employee = null;
          }
        });
    }

    commonRowChanged = (client: any, index: number) => {
        // We are on the last row and client & service are present,...
        // create new row for the client.
        if ((this.clients.length - 1) == index) {
            if (client && client.client && client.service) {
                let newClient = _.clone(client);
                newClient.service = null;
                newClient.priceLevels = this.basePriceLevels.slice(0);
                newClient.priceLevel = this.basePriceLevels[0].id;
                newClient.employee = null;
                newClient.genderPreference = Meevo.Model.EmployeeGenderSearchEnum.AnyEmployee.toString();

              // This should ensure the DOM updates prior to attempting to set focus on the new line's service typeahead.
              this.$timeout(() => {
                  this.addNewClient(newClient);
                  this.$scope.$apply();
                })
                .then(function() {
                  var control = angular.element('meevo-type-ahead#opensesame-service-' + (index + 1));
                  control.find('input').focus();
                  return true;
                  });
            }
        }
    }

    addNewClient = (newClient: any) => {
      this.clients.push(newClient);
    }

    showDaySelector = (): boolean => {
      var type = Number(this.scan.dateType);
      return type === Meevo.Model.ScanDateTypeEnum.NextWeek ||
        type === Meevo.Model.ScanDateTypeEnum.ThisWeek ||
        type === Meevo.Model.ScanDateTypeEnum.Specific;
    }

    showSpecificEmployee = (client: any): boolean => {
      var type = Number(client.genderPreference);
      return type === Meevo.Model.EmployeeGenderSearchEnum.SpecificEmployee;
    }

    dateTypeChanged = () => {
      this.scan.filter.days = [0, 1, 2, 3, 4, 5, 6];

      if (Number(this.scan.dateType) === Meevo.Model.ScanDateTypeEnum.Specific) {
        this.toggleDateSelect();
      }
    }

    showDateText = () => {
      return Number(this.scan.dateType) === Meevo.Model.ScanDateTypeEnum.Specific && this.startDate && this.endDate;
    }

    showTimeText = () => {
      return Number(this.scan.timeType) !== Meevo.Model.ScanTimeTypeEnum.Anytime;
    }

    getTimeText = () => {
      var dateFilter = this.$filter("date");
      var timeString = "";

      switch (Number(this.scan.timeType)) {
        case Meevo.Model.ScanTimeTypeEnum.StartsAfter:
          timeString = dateFilter(this.startTime, "shortTime");
          break;
        case Meevo.Model.ScanTimeTypeEnum.EndsBefore:
          timeString = dateFilter(this.endTime, "shortTime");
          break;
        case Meevo.Model.ScanTimeTypeEnum.Custom:
          timeString = dateFilter(this.startTime, "shortTime") + " - " + dateFilter(this.endTime, "shortTime");
          break;
      }

      return timeString;
    }

    timeTypeChanged = () => {
      if (Number(this.scan.timeType) !== Meevo.Model.ScanTimeTypeEnum.Anytime) {
        this.startTime = this.defaultStartTime;
        this.endTime = this.defaultEndTime;
        this.toggleTimeRangeSelect();
      }
    }

    requireSameResourceChanged = () => {
      if (this.scan.requireSameResource) {
        this.scan.multipleClients = true;
      }
    }

    getOpenings = (isRescan:boolean, isMoreResults:boolean) => {

      var scanLocation = this.effectiveLocationId;

      var okToScan = this.clients.length > 0 &&
       scanLocation &&
        _.some(this.clients, (service: any) => {
            return service.client &&
                service.service
            ;
        });

      if (okToScan) {

        if (!isMoreResults) {
          this.numWeeksToAdd = isRescan ? this.numWeeksToAdd + 1 : 0;
        }

        var sd = this.scan.dateType == Model.ScanDateTypeEnum.FirstAvailable ? 
          this.getThisWeekStartMoment(this.getLocationAdjustedMoment()).startOf('day').toDate() : 
          this.startDate;
        var ed = this.scan.dateType == Model.ScanDateTypeEnum.FirstAvailable ? moment(sd).add(6, 'days').toDate() : this.endDate;

        var request = {
          scanOrigin: Meevo.Model.ScanOriginEnum.Default,
          scanDateType: Number(this.scan.dateType),
          scanTimeType: Number(this.scan.timeType),
          asLocationId: scanLocation,
          maxWaitTimeBetweenServices: this.scan.maxWait,
          maxStartTimeWait: this.scan.maxWait,
          requireSameStartTime: this.scan.multipleClients,
          requireSameResource: this.scan.requireSameResource,
          scanServices: [],
          startTime: this.startTime,
          endTime: this.endTime,
          startDate:  sd,
          endDate: ed,
          daysToExclude: _.difference([0, 1, 2, 3, 4, 5, 6], this.scan.filter.days),
          isRescan: false,
          numWeeksToAdd: this.numWeeksToAdd,
          appointmentBufferMinutes: this.appointmentBufferMinutes,
          excludeRanges: this.getExcludeRanges(isMoreResults)
        };

        _.forEach(this.clients,
        (serviceRequest: any) => {
          if (serviceRequest.client && serviceRequest.service) {
            request.scanServices.push({
              clientId: serviceRequest.client.id,
              serviceId: serviceRequest.service.id,
              employeeId: (serviceRequest.employee ? serviceRequest.employee.id : null),
              genderPreferenceEnum: Number(serviceRequest.genderPreference),
              employeeGenderSearchEnum: Number(serviceRequest.genderPreference),
              priceLevel: (Number(serviceRequest.priceLevel) > 0 ? Number(serviceRequest.priceLevel) : null)
            });
          }
        });

        // Pass the correct request times
        if (Number(this.scan.timeType) !== Meevo.Model.ScanTimeTypeEnum.Anytime) {
          switch (Number(this.scan.timeType)) {
            case Meevo.Model.ScanTimeTypeEnum.EndsBefore:
              request.startTime = this.startTime;
              // Force scan engine to evaluate start and end times
              request.scanTimeType = Number(Meevo.Model.ScanTimeTypeEnum.Custom);
              break;
            case Meevo.Model.ScanTimeTypeEnum.StartsAfter:
              request.endTime = this.endTime;
              // Force scan engine to evaluate start and end times
              request.scanTimeType = Number(Meevo.Model.ScanTimeTypeEnum.Custom);
              break;
            default:
              break;
          }
        }

        let uri = `/${this.appSettings.API_ROOT}/CallCenter/Opening/List`;

        this.busyService.start();

        var trackingRequest = _.omit(request, ['scanOrigin', 'scanDateType', 'scanTimeType']);
        trackingRequest.scanOrigin = Meevo.Model.ScanOriginEnum[Meevo.Model.ScanOriginEnum.Default];
        trackingRequest.scanDateType = Meevo.Model.ScanDateTypeEnum[this.scan.dateType];
        trackingRequest.scanTimeType = Meevo.Model.ScanTimeTypeEnum[this.scan.timeType];
        _.forEach(trackingRequest.scanServices, (service: any) => {
            service.genderPreference = Meevo.Model.EmployeeGenderSearchEnum[service.genderPreference];
         delete service.genderPreferenceEnum;
        });
        var trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.BookingAgentPage, Meevo.Model.VerbEnum.ScanButtonClicked, trackingRequest, null);
          this.trackingService.saveTrackingInfo(trackingItem);

        this.dataService.customMethodData(uri, 'POST', request)
          .then((results: any) => {
            this.openings = results.data;
            this.lastOpeningTime = undefined;
            var totalOpenings = 0;

            _.forEach(this.openings, (day: any) => {
              _.forEach(day.openingTimeContainers, (time: any) => {
                totalOpenings += time.openingContainers.length;
                this.lastOpeningTime = time.time;
              });
            });

            if (this.openings != null && totalOpenings === 0) {
              if (this.showAddToWaitList === 0) this.showAddToWaitList = 1;
              if (this.showMissedOpportunity === 0 ) this.showMissedOpportunity = 1;
              this.showMoreResults = false;
                  this.modalService.alert("MESSAGE_NO_OPENINGS_FOUND", Components.Modal.ModalTranslationModes.Translate);
            } else if (totalOpenings > 0) {
              this.showMoreResults = true;
            }

            return results.data;
          })
          .finally(() => {
            this.busyService.stop();
              this.currentCallCenterScreen = 1;
          });

      }
    }

    showServiceDescription = (service: any) => {
      if (service) {
        let options = {
          templateUrl: "app/plugins/callCenter/views/serviceDescription.modal.html",
          controller: "meevo.plugins.callCenter.serviceDescriptionModalController",
          controllerAs: "vm",
          bindToController: true,
          skipHide: true,
          locals: {
            service: {
              shortcut: service.shortcut,
              displayName: service.displayName,
              description: service.description
            }
          }
        }
        this.modalService.showCustom(options);
      }
    }
    reset = () => {
        this.location = undefined;
        this.excludeScanDateTimeRanges = [];
        this.locationUpdated();
    }

    viewBook = () => {
      this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
          stateName: this.appSettings.ROUTE_NAMES.appointmentBook,
          stateParams: {
              asLocation: this.location
          }
      });
    }
    emulate = () => {
      const locationId = this.location ? this.location.locationId : undefined;
      const storeName = this.location ? this.location.storeName : this.loggedInLocation.storeName;
      this.showViewBook = false;
      return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}${this.emulationUrl}`, 'POST', { newLocationId: locationId }, {skipInterceptor: true})
        .then((response: angular.IHttpPromiseCallbackArg<Components.Common.IEmulateResponse>) => {
          this.previousLocation = this.location;

          if (Model.Guard.isNothing(response.data)) {
            return;
          }

          if (Model.Guard.isSomething(response.data.security)) {
            this.securityService.emulateLocationSecurity(response.data.security);
          }
          
          if (Model.Guard.isSomething(response.data.identity)) {
            const identity = response.data.identity;
            identity.systemSettings = this.identityService.current().systemSettings;
            identity.tenantData = this.identityService.current().tenantData;

            this.identityService.setIdentity(identity);
            this.$rootScope.$broadcast(Components.Common.Messages.UPDATE_LOCATION_NAME, { locationName: storeName });
            
            if (Model.Guard.isSomething(identity.effectiveCallCenterId)) {
              this.$window.localStorage.setItem(Components.Common.Constants.CALL_CENTER_EMULATION_STORAGE, JSON.stringify({
                asImpersonateLocationId: identity.asImpersonateLocationId,
                effectiveCallCenterId: identity.effectiveCallCenterId,
                loggedInLocation: identity.locationId,
                emulationId: Guid.newGuid(),
                userId: identity.userId
              }));
            } else {
              this.$window.localStorage.removeItem(Components.Common.Constants.CALL_CENTER_EMULATION_STORAGE);
            }
          }
          
          if (Model.Guard.isSomething(response.data.businessHours)) {
            this.setDefaultTimes(response.data.businessHours);
          }
          
          if (Model.Guard.isSomething(response.data.appointmentBookSettings)) {
            this.setLocSettings(response.data.appointmentBookSettings);
          }

          if (Model.Guard.isSomething(response.data.timeZoneOffset) || response.data.timeZoneOffset === 0) {
            this.timeZoneOffset = response.data.timeZoneOffset;
          }

          if (this.clients.length < 1 && Model.Guard.isSomething(this.location)) {
            this.addClient();
          }
          
          this.menuService.refreshCallCenterMenuItems();
        })
        .catch((error) => {
          this.location = this.previousLocation;
          let message = error.data.responseStatus.message;
          this.loggingService.error(`Booking Agent emulation failed. ${message}`);

          if (error.status === 403) {
            const checkAccessText = this.$translate.instant('ERROR_HTTP_403_CALL_CENTER_EMULATE');
            this.securityService.checkSecurityItem(message).then((securityItem) => {
              this.securityService.showDenyWarning(securityItem.securityKeyPath, message, checkAccessText);
            });
          } else {
            message = this.$translate.instant('ERROR_HTTP_UNKNOWN');
            this.$rootScope.$emit(Meevo.Components.Common.Messages.SERVER_VALIDATION, message, Model.NotificationModeType.Modal, true);
          }

        })
        .finally(() => {
          this.showViewBook = true;
        });
    }

    bookAppointment = (opening: any) => {
      var services = opening.openingContainers[0].serviceOpenings;
      _.forEach(services, (service: any) => {
        var client = _.find(this.clients, (client: any) => {
          return client.service && client.client.id === service.clientId;
        });

        if (client) {
            
            var middleName = "";

            if (client.client.middleName) // Check if client has a middle name
                middleName = client.client.middleName;

            service.clientName = client.client.lastName + ", " + client.client.firstName + " " + middleName;
        }
      });

      let options = {
        templateUrl: "app/plugins/callCenter/bookAppointmentModal.template.html",
        controller: "meevo.plugins.callCenter.bookAppointmentModalController",
        controllerAs: "vm",
        bindToController: true,
        skipHide: true,
        locals: {
          message: "Please confirm you wish to book the following appointment:",
          services: services,
          location: this.location,
          showEmpName: this.appointmentBookSettings.displaysEmployeeNameInListOfOpenings
        }
      }

      this.modalService.showCustom(options)
        .then((response: boolean) => {
          var openingToBook = {
            asLocationId: this.effectiveLocationId,
            openingContainer: opening.openingContainers[0],
            payingClientId: (this.payingClient ? this.payingClient.id : null),
            appointCategoryId: (this.scan.appointCat ? this.scan.appointCat.id : null)
          };

          var addressServices = _.filter(this.clients, (client: any) => {
            return client.service && client.service.isAddressRequired;
          });

          // Show address modal for each service that requires it.
          if (addressServices.length > 0) {
            _.forEach(addressServices, (service: any, index: number) => {
              let uri = `/${this.appSettings.API_ROOT}/Client/${service.client.id}`;
              this.dataService.customMethodData(uri, 'GET', null)
                .then((response: any) => {
                  let options = {
                    templateUrl: "app/plugins/callCenter/serviceAddressModal.template.html",
                    controller: "meevo.plugins.callCenter.serviceAddressModalController",
                    controllerAs: "vm",
                    bindToController: true,
                    skipHide: true,
                    locals: {
                      service: service.service,
                      clientInfo: response.data
                    }
                  }

                  this.modalService.showCustom(options)
                    .then((response: any) => {
                      if (response.isAddressComplete) {
                        var opening = _.find(openingToBook.openingContainer.serviceOpenings, (openingService: any) => {
                          return openingService.serviceId === service.service.id;
                        });

                        if (opening) {
                          opening.address1 = response.address1;
                          opening.address2 = response.address2;
                          opening.city = response.city;
                          opening.state = response.state;
                          opening.zipCode = response.zipCode;
                          opening.country = response.country;
                        }

                        if (index === addressServices.length - 1) {
                          this.finalizeAppointment(openingToBook);
                        }
                      }
                    });
                });

            });
          } else {
            this.finalizeAppointment(openingToBook);
          }

          return response;
        });
    }

    finalizeAppointment = (openingToBook: any) => {
      // Check UDFs
      for (var i = 0; i < this.clients.length; i++) {
        if (this.clients[i].service && this.clients[i].service.hasUdfs && this.clients[i].service.udfs) {
          openingToBook.openingContainer.serviceOpenings[i].answers = this.clients[i].service.udfs.answers;
        }
      }

      let uri = `/${this.appSettings.API_ROOT}/CallCenter/Appointment`;
      this.busyService.start();

      this.dataService.customMethodData(uri, 'POST', openingToBook)
        .then((results: any) => {
          this.modalService.alert("Appointment(s) successfully booked.");
          this.resetCriteria();
          return results.data;
        })
        .catch((response: any) => {
          this.modalService.error("One or more appointments are no longer available. Please re-scan and try again.");
          return response;
        })
        .finally(() => {
          this.busyService.stop();
          this.addClient();
        });
    }

    setDefaultTimes = (businessHours: any) => {
      let dayOfWeek;
      switch (moment().day()) {
        case 0:
          dayOfWeek = Meevo.Model.WeekdayNameEnum.Sunday;
          break;
        case 1:
          dayOfWeek = Meevo.Model.WeekdayNameEnum.Monday;
          break;
        case 2:
          dayOfWeek = Meevo.Model.WeekdayNameEnum.Tuesday;
          break;
        case 3:
          dayOfWeek = Meevo.Model.WeekdayNameEnum.Wednesday;
          break;
        case 4:
          dayOfWeek = Meevo.Model.WeekdayNameEnum.Thursday;
          break;
        case 5:
          dayOfWeek = Meevo.Model.WeekdayNameEnum.Friday;
          break;
        case 6:
          dayOfWeek = Meevo.Model.WeekdayNameEnum.Saturday;
          break;
      }

      let hours: any = _.findWhere(businessHours.businessHours, { 'weekdayName': dayOfWeek });
      if (hours) {
        this.defaultStartTime = hours.startTime;
        this.defaultEndTime = hours.endTime;
      }
    }

    automaticallyUpdateLocationAndEmulate = (newLocationId: number, skipClosingTabs: boolean = false) => {
      
      if (!skipClosingTabs) {
        this.$rootScope.$broadcast(Components.Common.Messages.CLOSE_REMOTE_CONTEXTS);
      }

      if (!newLocationId) {
        this.location = this.loggedInLocation;
        this.emulate();
        return;
      }
      this.dataService
              .customMethodData(`/${this.appSettings.API_ROOT}/Location/${newLocationId}`,"GET", null)
              .then(response => {
                this.location = response.data;
                this.emulate();
              });
    }

    private getThisWeekStartMoment(today: moment.Moment): moment.Moment {

      const weekStart = Model.WeekdayNameEnum[this.appointmentBookSettings.startAppointmentBookDayOn];
      if (moment(today).day(weekStart).toDate() <= today.toDate()) {
        return moment(today).day(weekStart);
      }

      return moment(today).day(weekStart).add(-7, 'days');
    }

    private getLocationAdjustedMoment() {
      return moment().utcOffset(this.timeZoneOffset).add(this.timeZoneOffset, 'minutes').startOf('day').locale('en-us');
    }

    private getExcludeRanges(isMoreResults: boolean): Model.DateTimeRange[] {
      if (!isMoreResults || !this.openings || this.openings.length < 1) {
        this.excludeScanDateTimeRanges = [];
        return [];
      }

      const openings = this.openings.filter(opening => opening.openingTimeContainers.length > 0).map(opening => { 
        return {
          startDateTime: opening.date,
          endDateTime: moment(new Date(_(opening.openingTimeContainers).last().time)).add('minutes', 1).toDate()
        };
      });

      openings.forEach(opening => {
        const matchingDateRange = this.excludeScanDateTimeRanges
          .find(excludeScanDateTimeRange => moment(excludeScanDateTimeRange.startDateTime).startOf('day').isSame(opening.startDateTime));
        if (matchingDateRange) {
          matchingDateRange.endDateTime = opening.endDateTime;
          return;
        }
        this.excludeScanDateTimeRanges.push({
          startDateTime: opening.startDateTime,
          endDateTime: opening.endDateTime
        });
      });

      return this.excludeScanDateTimeRanges;
    }
 }


  angular.module("meevo.plugins.callCenter")
      .controller("meevo.plugins.callCenter.CallCenterController", CallCenterController);
}